<div
  *ngIf="productData"
  class="productAssinatura"
  [ngClass]="{
    preferred: productData && productData.preferred,
    discount:
      productData && !productData.preferred && productData.percentDiscount,
    shopWindowReduced: shopWindowReduced
  }"
>
  <section
    class="header"
    [ngClass]="{
      empty:
        productData && !(productData.preferred || productData.percentDiscount)
    }"
  >
    <span *ngIf="productData.preferred || productData.percentDiscount">
      <p *ngIf="productData.preferred">Recomendado</p>
      <p *ngIf="!productData.preferred && productData.percentDiscount">
        Desconto de {{ productData.percentDiscount }}%
      </p>
    </span>
  </section>
  <section
    class="bodyExpanded"
    [ngClass]="{
      curveTop:
        productData && !(productData.preferred || productData.percentDiscount),
      preferred: productData && productData.preferred,
      discount:
        productData && !productData.preferred && productData.percentDiscount,
      shopWindowReduced: shopWindowReduced
    }"
  >
    <div class="body" [ngClass]="{ open: dropdownOpened }">
      <div class="" left-side>
        <section class="title">
          <span class="name">{{ productData.cardTitle }}</span>
        </section>
        <div class="value">
          <section
            class="fullValue"
            [ngClass]="{ empty: !productData.percentDiscount }"
          >
            <span *ngIf="productData.percentDiscount">
              De R$ {{ formatCurrency(productData.baseValue) }}
            </span>
            <span *ngIf="productData.percentDiscount">por</span>
          </section>
          <section class="finalValue">
            <p>
              <span>R$ </span>
              <span class="integerPart">{{ productData.integerPart }}</span>
              <span class="decimalPart" *ngIf="productData.decimalPart !== 0"
                >,{{ productData.decimalPart }}
              </span>
              <span *ngIf="productData.product.periodicity == 'Mensal'"
                >/mês</span
              >
              <span *ngIf="productData.product.periodicity == 'Anual'"
                >/ano</span
              >
            </p>
          </section>
        </div>

        <section
          class="bonus"
          [ngClass]="{
            hasBonus: productData.extraBalanceValueSum > 0
          }"
        >
          <span *ngIf="productData.extraBalanceValueSum > 0"
            ><b>
              + R$ {{ formatCurrency(productData.extraBalanceValueSum) }}
            </b>
            <br />de bônus</span
          >
        </section>
      </div>
      <section class="buttons">
        <button class="buy" (click)="onBuyClicked()">
          COMPRAR
        </button>
        <button
          *ngIf="showDetail"
          class="drop"
          [ngClass]="{ colapse: dropdownOpened }"
          (click)="onDropClicked()"
        >
          <img src="/assets/images/drop-down-icon.png" class="icon" />
        </button>
      </section>
    </div>

    <section *ngIf="showDetail" class="featureList" [ngClass]="{ open: dropdownOpened }">
      <div class="featureItem" *ngFor="let feature of productData.featureList">
        <span
          ><b>{{ feature.name }}</b></span
        >
        <span>{{ feature.toValue }}</span>
      </div>
    </section>
  </section>
</div>
